import { defaultReducers, defaultInitialState } from "../../../../../redux/_common";
import { createSlice } from "@reduxjs/toolkit";


const initialState = {...defaultInitialState};
const reducers = {...defaultReducers};

export const conditionTypesSlice = createSlice({
  name: "conditionTypes",
  initialState,
  reducers,
});

